<div id="safety-productivity-report"></div>